'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isNull = require('lodash/isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components

// import '@bodhi-project/antrd/lib/restorative-auroville/3.10.0/row/style/css'

// import '@bodhi-project/antrd/lib/restorative-auroville/3.10.0/col/style/css'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
var Fragment = _react2.default.Fragment;


var divisions = {
  byTwo: {
    half: [12, 12],
    golden: [15, 9],
    goldenAlt: [9, 15],
    bigGolden: [16, 8],
    bigGoldenAlt: [8, 16],
    threeQuarters: [18, 6],
    threeQuartersAlt: [6, 18]
  },
  byThree: {
    equal: [8, 8, 8]
  }

  // ----------------------------------------------------------------------------
  // ------------------------------------------------------------------ Component
  // ----------------------------------------------------------------------------
  /** Division */
};var Division = function Division(_ref) {
  var children = _ref.children,
      _ref$byThree = _ref.byThree,
      byThree = _ref$byThree === undefined ? false : _ref$byThree,
      _ref$half = _ref.half,
      half = _ref$half === undefined ? true : _ref$half,
      _ref$golden = _ref.golden,
      golden = _ref$golden === undefined ? false : _ref$golden,
      _ref$goldenAlt = _ref.goldenAlt,
      goldenAlt = _ref$goldenAlt === undefined ? false : _ref$goldenAlt,
      _ref$bigGolden = _ref.bigGolden,
      bigGolden = _ref$bigGolden === undefined ? false : _ref$bigGolden,
      _ref$bigGoldenAlt = _ref.bigGoldenAlt,
      bigGoldenAlt = _ref$bigGoldenAlt === undefined ? false : _ref$bigGoldenAlt,
      _ref$threeQuarters = _ref.threeQuarters,
      threeQuarters = _ref$threeQuarters === undefined ? false : _ref$threeQuarters,
      _ref$threeQuartersAlt = _ref.threeQuartersAlt,
      threeQuartersAlt = _ref$threeQuartersAlt === undefined ? false : _ref$threeQuartersAlt,
      _ref$custom = _ref.custom,
      custom = _ref$custom === undefined ? null : _ref$custom,
      props = _objectWithoutProperties(_ref, ['children', 'byThree', 'half', 'golden', 'goldenAlt', 'bigGolden', 'bigGoldenAlt', 'threeQuarters', 'threeQuartersAlt', 'custom']);

  /** Children */
  var div1 = children[0];
  var div2 = children[1];
  var div3 = byThree === true ? children[2] : _react2.default.createElement(Fragment, null);

  /** By two or three */
  var byThis = byThree === true ? 'byThree' : 'byTwo';

  /** Widths */
  var col1Width = 0;
  var col2Width = 0;
  var col3Width = 0;

  /** Division */
  var thisDivision = byThree === true ? 'equal' : 'half';
  if (byThis === 'byTwo') {
    if (half === true) {
      thisDivision = 'half';
    }
    if (golden === true) {
      thisDivision = 'golden';
    }
    if (goldenAlt === true) {
      thisDivision = 'goldenAlt';
    }
    if (bigGolden === true) {
      thisDivision = 'bigGolden';
    }
    if (bigGoldenAlt === true) {
      thisDivision = 'bigGoldenAlt';
    }
    if (threeQuarters === true) {
      thisDivision = 'threeQuarters';
    }
    if (threeQuartersAlt === true) {
      thisDivision = 'threeQuartersAlt';
    }

    /** Widths */
    col1Width = (0, _isNull2.default)(custom) ? divisions[byThis][thisDivision][0] : custom[0];
    col2Width = (0, _isNull2.default)(custom) ? divisions[byThis][thisDivision][1] : custom[1];
  } else {
    /** Widths */
    col1Width = (0, _isNull2.default)(custom) ? divisions[byThis][thisDivision][0] : custom[0];
    col2Width = (0, _isNull2.default)(custom) ? divisions[byThis][thisDivision][1] : custom[1];
    col3Width = (0, _isNull2.default)(custom) ? divisions[byThis][thisDivision][2] : custom[2];
  }

  return _react2.default.createElement(
    _row2.default,
    _extends({
      gutter: { xs: 12, sm: 18, md: 24, lg: 30, xl: 36, xxl: 42 }
    }, props),
    _react2.default.createElement(
      _col2.default,
      { sm: 24, md: 24, lg: col1Width },
      div1
    ),
    _react2.default.createElement(
      _col2.default,
      { sm: 24, md: 24, lg: col2Width },
      div2
    ),
    byThree === true && _react2.default.createElement(
      _col2.default,
      { sm: 24, md: 24, lg: col3Width },
      div3
    )
  );
};

Division.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.element,
  half: _propTypes2.default.bool,
  golden: _propTypes2.default.bool,
  goldenAlt: _propTypes2.default.bool

  // ----------------------------------------------------------------------------
  // -------------------------------------------------------------------- Exports
  // ----------------------------------------------------------------------------
} : {};exports.default = Division;
module.exports = exports['default'];